import styled from 'styled-components';
import Logo from './svg/logo.svg';

export const Title = styled.h1`
  font-size: calc(${props => props.theme.fonts.baseSize} + 2vmin);
  font-weight: 500;

  span {
    color: ${props => props.theme.colors.primary};
  }
`;

const PageWrap = styled.section`
  align-items: center;
  display: flex;
  font-size: 4vmin;
  justify-content: center;
  min-height: ${props => props.theme.pageWrap.height};
  text-align: center;
  width: ${props => props.theme.pageWrap.width};

  .fade-enter & {
    opacity: 0.01;
    //transform: translateY(20px);
  }

  .fade-enter-active & {
    opacity: 1;
    //transform: translateY(0);
    transition: all 300ms ease-out;
  }

  .fade-exit & {
    opacity: 1;
    //transform: translateY(0%);
  }

  .fade-exit-active & {
    opacity: 0.01;
    //transform: translateY(20px);
    transition: all 300ms ease-out;
  }
`;

export const PageTransition = styled.section`
  align-items: center;
  display: none;
  flex-direction: column;
  justify-content: center;
  height: ${props => props.theme.pageWrap.height};
  position: relative;
  width: ${props => props.theme.pageWrap.width};

  &::after,
  &::before {
    background: ${props => props.theme.colors.white} url(${Logo}) no-repeat
      center;
    background-attachment: fixed;
    background-size: 50px;
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(100vw);
    transition: transform ${props => props.theme.transition.wipe.duration}
        ${props => props.theme.transition.easeInOut},
      opacity ${props => props.theme.transition.durationLong}
        ${props => props.theme.transition.easeInOut};
    z-index: ${props => props.theme.zIndex.overlay};
  }

  &::after {
    background: ${props => props.theme.colors.primary} url(${Logo}) no-repeat
      center;
    transition-delay: ${props => props.theme.transition.wipe.delay};
    background-attachment: fixed;
    background-size: 50px;
  }

  /* ENTER */
  &.game-wrap-enter,
  &.game-wrap-enter-active,
  &.game-wrap-enter-done {
    display: flex;

    &::before,
    &::after {
      transform: translateX(100vw);
    }
  }

  &.game-wrap-enter-active::before,
  &.game-wrap-enter-active::after {
    transform: translateX(0);
  }

  &.game-wrap-enter-done::before,
  &.game-wrap-enter-done::after {
    transform: translateX(-100vw);
  }

  /* EXIT */
  &.game-wrap-exit {
    display: flex;

    &::before,
    &::after {
      transform: translateX(-100vw);
    }
  }

  &.game-wrap-exit-active {
    display: flex;

    &::before,
    &::after {
      transform: translateX(100vw);
    }
  }

  &.game-wrap-exit-done {
    display: none;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    min-height: ${props => props.theme.gameSelectorWindow.minHeight};
  }
`;

export default PageWrap;



// WEBPACK FOOTER //
// ./src/components/pages/Page/Page.styled.js